export default __webpack_public_path__ + "6cf2737868d430f3226cf1c4fca53c57.svg";